import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { MillwrightWorkedHours } from '@/apis/workedHours/types/workedHours';
import { millwrightWorkedHoursFromApiAdapter } from '@/apis/workedHours/adapters/millwrightWorkedHoursFromApiAdapter';
import { prepareHeadersWithAuthorization as prepareHeaders } from '@/apis/headers';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export interface MillwrightWorkedHoursParams {
  empId: number;
  outageId?: number;
}

export const workedHoursApi = createApi({
  reducerPath: 'workedHoursApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL, prepareHeaders }),
  endpoints: (builder) => ({
    getMillwrightWorkedHours: builder.query<
      MillwrightWorkedHours,
      MillwrightWorkedHoursParams
    >({
      query: ({ empId, outageId }) => ({
        url: `/hours-worked/employee/summary`,
        params: {
          ...(outageId && { outage_id: outageId }),
          ...(empId && { emp_id: empId }),
        },
      }),
      transformResponse: millwrightWorkedHoursFromApiAdapter,
    }),
  }),
});

export const { useGetMillwrightWorkedHoursQuery } = workedHoursApi;
